import { useSelector } from 'react-redux';
import { filterObject } from 'rambdax';
import useSWRInfinite from 'swr/infinite';
import { DEFAULT_PAGE_SIZE } from '@/lib/constants/common';
import { fetcher } from '@/utils/services';
import { snakeCaseKeys } from '@/utils/transformKeys';

const useInfiniteFeed = (params = {}) => {
  const ownerOrgId = useSelector(
    (state) => state.authentication?.ownerOrgId || null,
  );
  const getKey = (pageIndex, previousPageData) => {
    if (!ownerOrgId || (previousPageData && !previousPageData?.feedItems))
      return null;
    const searchParams = new URLSearchParams(
      snakeCaseKeys(
        filterObject((val) => typeof val !== 'undefined', {
          ...params,
          pageFrom: pageIndex * DEFAULT_PAGE_SIZE,
          pageSize: DEFAULT_PAGE_SIZE,
        }),
      ),
    );
    searchParams.sort();
    return `orgs/${ownerOrgId}/feed-items/search?${searchParams.toString()}`;
  };

  const { data, error, size, setSize } = useSWRInfinite(getKey, fetcher);

  return { data, error, size, setSize };
};

export default useInfiniteFeed;
